// extracted by mini-css-extract-plugin
export default {"EventMetrics":"EventMetrics_EventMetrics__Vz8wT","metricCard":"EventMetrics_metricCard__5Bdlb","num":"EventMetrics_num__Qh1vk","label":"EventMetrics_label__Asd61"};